import { twMerge } from "tailwind-merge";

type VerticalLineProps = {
  className?: string;
};

/**
 * A vertical line component to be used in the UI
 * - The component is used to separate sections in the UI
 * @param className - The class name to be applied to the component
 * @returns div with bg-gray-100 h-4 w-px md:h-8 md:my-[-2px] classes
 */
function VerticalLine({ className }: VerticalLineProps) {
  return <div className={twMerge("bg-gray-100 h-4 w-px md:h-8 md:my-[-2px]", className)} />;
}

export default VerticalLine;
